<template>
  <v-combobox
    v-model="mySector"
    class="sector-box"
    :items="items"
    :label="label"
    :disabled="disabled"
    :loading="loading"
    :hide-details="hideDetails"
    maxLength="100"
  />
</template>

<script>
const { getSummary } = require('@/lib/api')

export default {
  props: {
    value: {
      type: String,
      default: null,
    },
    group: {
      type: null,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    hideDetails: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      loading: false,
      mySector: null,
      items: [],
    }
  },
  watch: {
    mySector: {
      handler() {
        if (this.mySector === this.value) return
        this.$emit('input', this.mySector)
      },
      deep: true,
    },
    value: {
      handler() {
        this.mySector = this.value
      },
      immediate: true,
    },
  },
  created() {
    this.init()
  },
  methods: {
    async init() {
      this.loading = true
      const sectorSummary = await getSummary({ type: 'sector', queryString: { group: this.group } })
      this.items = sectorSummary.data
      this.loading = false
    },
  },
}
</script>

<style lang="scss">
.sector-box {
  .v-select__selections {
    margin-bottom: 0px !important;
  }
}
</style>
